import { Button, Grid, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Alert, Form } from "../../../layout";
import { InputPass } from "../../../controls";
import { Model, UseForm } from "../../../hooks";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../../api/actions/pos";
import { useContext } from "react";
import { AppContext } from "../../../App";
import { controller, endpoints } from "../../../api/actions/api";
import { ToFormData } from "../../../hooks/Method";

const ChangePass = (props) => {
  const { setActiveStep, setForgotVal, forgotVal, _getByObj } = props;
  const { ForgotMdl } = Model();
  const navigate = useNavigate();
  const [err, setErr] = useState();
  const { setCLoader } = useContext(AppContext);
  const { values, setValues, errors, setErrors, handleInpPass, passValid } =
    UseForm(ForgotMdl);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  const validateForm = () => {
    let temp = {};
    temp.password =
      values.password !== ""
        ? !passValid.passValid
          ? ""
          : ""
        : "Password is required.";
    temp.confirmPass =
      values.confirmPass !== ""
        ? !passValid.match
          ? "Password and Confirm password not match."
          : ""
        : "Confirm Password is required.";
    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const submitForm = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setCLoader(true);
      values.forgotStep = 3;
      const onComplete = (res) => {
        setCLoader(false);
        res.status === 200 ? navigate("/dashboard") : setErr(res.msg);
      };
      _getByObj(
        endpoints.Auth + controller.Forgot,
        ToFormData(values),
        actions.ActionType.Auth,
        onComplete
      );
    }
  };

  useEffect(() => {
    setValues(forgotVal);
    return () => {
      setValues();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setForgotVal({ ...values });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  console.log("values: ", values);

  return (
    <>
      <Form noValidate onSubmit={submitForm}>
        <Grid container className="p-15 pt-0" maxWidth={400} spacing={3}>
          <Grid item xs={12} className="tx-center gray-color">
            <Grid className="pos-relative mb-20">
              <span className="fw-6 fs-20 tx-upp">Change Password</span>
              <div className="bs-bottom mx-w-60 m-auto mt-5" />
            </Grid>
          </Grid>
          {err && (
            <Grid item xs={12}>
              <Typography variant="subtitle1" color="error">
                <span className="fw-6 tx-upp"> Error:&nbsp;</span> {err}
              </Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <InputPass
              label="New Password"
              name="password"
              value={values.password}
              onChange={handleInpPass}
              error={errors.password}
              className="input-primary w-100pr"
            />
          </Grid>
          <Grid item xs={12}>
            <InputPass
              label="Confirm Password"
              name="confirmPass"
              value={values.confirmPass}
              onChange={(e) => handleInpPass(e, true)}
              error={
                errors.confirmPass !== "" &&
                values.password !== "" &&
                !passValid.match &&
                values.confirmPass !== ""
                  ? "Password and Confirm password not match"
                  : errors.confirmPass
              }
              className="input-primary w-100pr"
            />
          </Grid>
          <Grid item xs={12} className="text-center">
            <Button
              type="submit"
              size="large"
              className="btn-secondary w-100pr mb-10"
            >
              Change Password
            </Button>
          </Grid>
        </Grid>
      </Form>
      <Alert
        onClick={() => setActiveStep(undefined)}
        alert={alert}
        setAlert={setAlert}
      />
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapActionToProps = {
  _getByObj: actions.getByObj,
};

export default connect(mapStateToProps, mapActionToProps)(ChangePass);
